import React from 'react';
import { useNavigate, Navigate } from 'react-router-dom';
import { SuperUserSetupForm } from '../components/auth/SuperUserSetupForm';
import { useAuth } from '../contexts/AuthContext';

export const SuperUserSetupPage: React.FC = () => {
  const navigate = useNavigate();
  const { requiresSetup, setupLoading } = useAuth();

  // Redirect to login if setup is already complete
  if (!setupLoading && !requiresSetup) {
    return <Navigate to="/login" replace />;
  }

  const handleSuccess = () => {
    navigate('/login');
  };

  return <SuperUserSetupForm onSuccess={handleSuccess} />;
};
